<template>
  <b-dropdown
    variant="outline-secondary"
    toggle-class="checkbox-tag-dropdown-toggle"
    menu-class="checkbox-tag-dropdown-menu"
    no-caret
    block
  >
    <template #button-content>
      <div class="checkbox-tag-dropdown-tags">
        <b-form-tag
          v-for="option in selectedOptions"
          :key="option.value"
          class="mr-50 my-25"
          variant="danger"
          @remove="removeTag(option.value)"
        >
          {{ option.label }}
        </b-form-tag>
        <span
          v-if="selectedOptions.length === 0"
          class="text-muted"
        >{{ placeholder }}</span>
      </div>
      <feather-icon
        icon="ChevronDownIcon"
        size="16"
        class="checkbox-tag-dropdown-caret"
      />
    </template>

    <b-dropdown-form @click.stop>
      <b-form-checkbox
        :checked="value.length === 0"
        @change="checked => checked && $emit('input', [])"
      >
        {{ allLabel }}
      </b-form-checkbox>
      <b-form-checkbox-group
        :checked="value"
        class="pl-2 mt-50"
        stacked
        @input="val => $emit('input', val)"
      >
        <b-form-checkbox
          v-for="option in options"
          :key="option.value"
          :value="option.value"
        >
          {{ option.label }}
        </b-form-checkbox>
      </b-form-checkbox-group>
    </b-dropdown-form>
  </b-dropdown>
</template>

<script>
import {
  BDropdown, BDropdownForm, BFormCheckbox, BFormCheckboxGroup, BFormTag,
} from 'bootstrap-vue'

export default {
  components: {
    BDropdown,
    BDropdownForm,
    BFormCheckbox,
    BFormCheckboxGroup,
    BFormTag,
  },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    // [{ value, label }]
    options: {
      type: Array,
      required: true,
    },
    allLabel: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String,
      default: 'Select from list',
    },
  },
  computed: {
    selectedOptions() {
      return this.options.filter(option => this.value.includes(option.value))
    },
  },
  methods: {
    removeTag(val) {
      this.$emit('input', this.value.filter(v => v !== val))
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .checkbox-tag-dropdown-toggle {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  min-height: 38px;
  height: auto;
  background-color: #fff;
  text-align: left;
  white-space: normal;

  &:hover,
  &:focus,
  &:active {
    background-color: #fff !important;
  }
}

.checkbox-tag-dropdown-tags {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  flex: 1;
}

.checkbox-tag-dropdown-caret {
  flex-shrink: 0;
  margin-left: 0.5rem;
}

::v-deep .checkbox-tag-dropdown-menu {
  width: 100%;
  max-height: 260px;
  overflow-y: auto;
}
</style>
